import { SET_HEADER_TABS_CONFIG } from '@app/actions/_types';

const initialHeaderState = {
  tabs: [],
};

export default (state = initialHeaderState, { type, payload } = {}) => {
  if (type === SET_HEADER_TABS_CONFIG) {
    return { ...state, tabs: payload };
  }
  return state;
};
